import axios from "axios";
import { host } from "./utilities";

export const listCountriesAxios = () => (config) => axios.get(`${host()}/reference-data/countries`, config);
